import React, { useState, useRef } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import SEO from './SEO';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

const KARMA_LIST = [
  { id: 1, ta: 'அன்னப்ராசனம்', en: 'Annapraasanam (First Grain Feeding)', fee: '₹ 2,000' },
  { id: 2, ta: 'அக்ஷராப்யாஸம்', en: 'Aksharabhyaasam (Education & Alphabet Initiation)', fee: '₹ 2,500' },
  { id: 3, ta: 'ஜாதகர்மா', en: 'Jaadhakarma (Newborn Birth Rites)', fee: '₹ 10,000' },
  { id: 4, ta: 'உதகசாந்தி', en: 'Udakasaandhi (Purification & Wellbeing Chanting)', fee: '₹ 10,000' },
  { id: 5, ta: 'உபநயனம்', en: 'Upanayanam (Sacred Thread Ceremony)', fee: '₹ 15,000' },
  { id: 6, ta: 'உபாகர்மா', en: 'Upakarma (Annual Thread Renewal Rites)', fee: '₹ 1,000' },
  { id: 7, ta: 'தலை ஆவணியவிட்டம்', en: 'Thalai Aavani Avittam (First Upakarma for Newly Married)', fee: '₹ 5,000' },
  { id: 8, ta: 'பூச்சூட்டல்', en: 'Poochoottal (Flower Blessing Ceremony)', fee: 'தொடர்புகொள்ள' },
  { id: 9, ta: 'பும்ஸவனம்', en: 'Pumsavanam (Rites for Healthy Progeny)', fee: '₹ 5,000' },
  { id: 10, ta: 'ஸீமந்தம்', en: 'Seemantham (Mother & Child Wellbeing Ceremony)', fee: '₹ 5,000' },
  { id: 11, ta: 'ப்ரஸவ புண்யாஹம்', en: 'Prashava Punyaaham (Post-Birth Purification)', fee: '₹ 4,000' },
  { id: 12, ta: 'க்ரஹப்ரவேசம்', en: 'Grihapravesam (Vedic Housewarming)', fee: '₹ 10,000' },
  { id: 13, ta: 'நாளவேஷ்டின சாந்தி', en: 'Naalaveshtina Saandhi (Protection Rites)', fee: '₹ 5,000' },
  { id: 14, ta: 'கணபதி ஹோமம்', en: 'Ganapathi Homam (Obstacle Removal Homam)', fee: '₹ 10,000' },
  { id: 15, ta: 'நவக்ரஹ ஹோமம்', en: 'Navagraha Homam (Planetary Peace Homam)', fee: '₹ 15,000' },
  { id: 16, ta: 'தன்வந்தரி ஹோமம்', en: 'Dhanvantari Homam (Health & Healing Homam)', fee: '₹ 15,000' },
  { id: 17, ta: 'ஹயக்ரீவ ஹோமம்', en: 'Hayagriva Homam (Wisdom & Education Homam)', fee: '₹ 15,000' },
  { id: 18, ta: 'ஸ்ரீசுதர்ஸன ஹோமம்', en: 'Sri Sudarsana Homam (Protection & Divine Grace Homam)', fee: '₹ 25,000' },
  { id: 19, ta: 'பெருமாள் திருவாராதனம்', en: 'Perumal Thiruvaradhanam (Home Deity Worship)', fee: '₹ 1,000' },
  { id: 20, ta: 'வேத பாராயணம் (5 நாள் / 3 நாள் / 1 நாள்)', en: 'Veda Parayanam (5 Days / 3 Days / 1 Day)', fee: '₹ 10,000' },
  { id: 21, ta: 'திவ்யப்ரபந்த பாராயணம்', en: 'Divyaprabandha Parayanam (Sacred Tamil Hymns Recitation)', fee: '₹ 10,000' },
  { id: 22, ta: 'நிச்சயதார்த்தம்', en: 'Nischayadhaartham (Vedic Engagement)', fee: '₹ 10,000' },
  { id: 23, ta: 'விவாஹம் - கல்யாணம்', en: 'Vivaaham / Kalyanam (Vedic Marriage Ceremony)', fee: 'தொடர்புகொள்ள' },
  { id: 99, ta: 'மற்றவை (Other Vaidhika Karma...)', en: 'Other Vaidhika Karma...', fee: 'தொடர்புகொள்ள' },
];

const VaidhikaServicesPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    karmaDetail: 'அன்னப்ராசனம்',
    otherKarma: '',
    karmaDate: '',
    karmaPlace: '',
    address: '',
    vedaSampradaya: 'யஜூர் வேதம் - வடகலை',
  });

  const [loading, setLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const finalKarmaText = formData.karmaDetail === 'மற்றவை (Other Vaidhika Karma...)' 
    ? (formData.otherKarma || 'மற்ற கர்மா') 
    : formData.karmaDetail;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const generateWhatsAppMessage = () => {
    return `*ஸ்ரீ வைஷ்ணவ கேந்திரம் - வைதீக கர்மா முன்பதிவு / தொடர்பு*
--------------------------------------------
👤 *பெயர் (Name):* ${formData.name || 'வழங்கப்படவில்லை'}
📞 *தொடர்பு / வாட்ஸ்அப் எண்:* ${formData.phone || 'வழங்கப்படவில்லை'}
📿 *கர்மா விபரம்:* ${finalKarmaText}
📜 *வேதம் / ஸம்ப்ரதாயம்:* ${formData.vedaSampradaya}
📅 *கர்மா உத்தேசித்துள்ள தேதி:* ${formData.karmaDate || 'தேதி பின்னர் தெரிவிக்கப்படும்'}
📍 *கர்மா நடைபெறும் இடம்:* ${formData.karmaPlace || 'இடம் பின்னர் தெரிவிக்கப்படும்'}
🏠 *முகவரி:* ${formData.address || 'வழங்கப்படவில்லை'}
--------------------------------------------
ஸ்ரீ.உப.வே. ஸ்ரீநிவாசாசாரியார் ஸ்வாமிகள் அவர்களுக்கு, மேற்கண்ட வைதீக கர்மா குறித்து வாத்யார் & ஏற்பாடுகள் செய்ய தங்களை அணுகுகிறேன்.`;
  };

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone) {
      setErrorMessage('தயவுசெய்து தங்கள் பெயர் மற்றும் வாட்ஸ்அப் எண்ணை பதிவு செய்யவும் (Please enter Name & Phone)');
      return;
    }
    const message = generateWhatsAppMessage();
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/918610736302?text=${encodedMessage}`, '_blank');
  };

  const handleSubmitServer = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    
    if (!formData.name || !formData.phone) {
      setErrorMessage('தயவுசெய்து உங்கள் பெயர் மற்றும் வாட்ஸ்அப் எண்ணை உள்ளிடவும்.');
      return;
    }

    if (!recaptchaToken) {
      setErrorMessage('reCAPTCHA சரிபார்ப்பை முடிக்கவும்.');
      return;
    }

    setLoading(true);

    try {
      const subjectText = `Vaidhika Karma Request: ${finalKarmaText} by ${formData.name}`;
      const messageBody = `
Vaidhika Karma Inquiry Details:
----------------------------------
Name: ${formData.name}
Phone/WhatsApp: ${formData.phone}
Karma Selected: ${finalKarmaText}
Veda & Sampradaya: ${formData.vedaSampradaya}
Proposed Date: ${formData.karmaDate || 'Not specified'}
Place / City: ${formData.karmaPlace || 'Not specified'}
Communication Address: ${formData.address || 'Not specified'}
      `.trim();

      await axios.post(`${API}/contact/submit`, {
        name: formData.name,
        email: 'client-inquiry@ahobilam.com',
        phone: formData.phone,
        subject: subjectText,
        message: messageBody,
        recaptcha_token: recaptchaToken,
      });

      setSubmitSuccess(true);
      setFormData({
        name: '',
        phone: '',
        karmaDetail: 'அன்னப்ராசனம்',
        otherKarma: '',
        karmaDate: '',
        karmaPlace: '',
        address: '',
        vedaSampradaya: 'யஜூர் வேதம் - வடகலை',
      });
      setRecaptchaToken(null);
      if (recaptchaRef.current) recaptchaRef.current.reset();
    } catch (err) {
      console.error('Submission error:', err);
      setErrorMessage(err.response?.data?.detail || 'செய்தி அனுப்பவதில் சிரமம் ஏற்பட்டது. மீண்டும் முயற்சிக்கவும் அல்லது வாட்ஸ்அப் மூலம் தொடர்பு கொள்ளவும்.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#FAF6EE] min-h-screen text-[#2D3748] pb-16 font-sans">
      <SEO
        title="ஸ்ரீ வைஷ்ணவ கேந்திரம் | வைதீக சேவைகள் & சுப கர்மாக்கள் | Ahobilam.com"
        description="Sri Vaishnava Kendram - Established Aug 19, 1989. Authentic Poorvam & Aparam Vaidhika Karmas, Vadakalai/Thenkalai Vadhyar services all over India."
        keywords="Vaidhika Karmas, Sri Vaishnava Kendram, Vadhyar services, Upanayanam, Seemantham, Grihapravesam, Homam, Shradhdham, Vadakalai Thenkalai Purohit"
      />

      {/* Top Banner / Hero Section */}
      <div className="bg-gradient-to-r from-[#591717] via-[#7B1E1E] to-[#4A148C] text-[#FAF6EE] py-14 px-4 sm:px-6 lg:px-8 border-b-4 border-[#D4AF37] shadow-xl relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          
          <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 border border-[#D4AF37] text-[#FDF8ED] px-5 py-2 rounded-full text-sm font-semibold tracking-wide uppercase mb-4 shadow-sm">
            <span>🛕 ஸ்ரீ வைஷ்ணவ கேந்திரம்</span>
            <span>•</span>
            <span>நிறுவப்பட்ட நாள்: ஆகஸ்ட் 19, 1989 (36+ ஆண்டுகள் சேவை)</span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#FDF8ED] leading-tight mb-4 drop-shadow-md">
            சாஸ்திர ரீதியான வைதீக சேவைகள் &amp; சுப கர்மாக்கள்
          </h1>

          <p className="text-base sm:text-xl text-[#F5EDDA] max-w-4xl mx-auto leading-relaxed font-medium">
            பூர்வம் (சுப விசேஷங்கள்) &amp; அபரம் (வருடாந்திர ச்ராத்தங்கள்) உள்ளிட்ட அனைத்து வைதீக கர்மாக்களும் சாஸ்திர முறைப்படி ச்ரத்தையாக செய்து தரப்படும்.
          </p>

          {/* Online / Video Call Badge */}
          <div className="mt-4 bg-[#CC6600]/90 border border-[#D4AF37] text-[#FAF6EE] px-6 py-2.5 rounded-full inline-block text-xs sm:text-sm font-bold shadow-lg">
            💻 உள்ள நாடு மற்றும் வெளிநாட்டில் (NRI) உள்ளவர்களுக்கும் இவை அனைத்து (23) கர்மாக்களும் ஆன்லைன் (Video Call) மூலமாகவும் பண்ணிக்கொடுக்கப்படும்.
          </div>

          {/* Quick Contact Badge */}
          <div className="mt-8 flex flex-wrap justify-center items-center gap-4 text-sm sm:text-base font-semibold">
            <div className="bg-[#FAF6EE]/10 border border-[#D4AF37]/50 backdrop-blur-md text-[#FDF8ED] px-6 py-3 rounded-xl flex items-center gap-2 shadow-inner">
              <span>👨‍🏫 தொடர்புக்கு:</span>
              <span className="text-[#FDF8ED] font-bold">ஸ்ரீ.உப.வே. ஸ்ரீநிவாசாசாரியார் ஸ்வாமின்</span>
              <span className="text-[#D4AF37] text-xs">(MA, M.Phil, PhD)</span>
            </div>
            <a
              href="https://wa.me/918610736302"
              target="_blank"
              rel="noreferrer"
              className="bg-[#2D5A1E] hover:bg-[#1B5E20] text-[#FAF6EE] px-6 py-3 rounded-xl font-bold transition shadow-lg flex items-center gap-2 border border-[#D4AF37]"
            >
              <span>💬 வாட்ஸ்அப்பில் தொடர்பு கொள்ள: 8610736302</span>
            </a>
          </div>

        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">

        {/* Highlight Banner / Features Notice Box */}
        <div className="bg-[#FDF8ED] rounded-2xl border-2 border-[#D4AF37] p-6 sm:p-8 shadow-lg mb-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 bg-[#CC6600] text-[#FAF6EE] text-xs font-bold uppercase px-4 py-1.5 rounded-bl-xl shadow-md">
            சிறப்பம்சங்கள் (Specialities)
          </div>

          <h2 className="text-xl sm:text-2xl font-extrabold text-[#591717] mb-6 flex items-center gap-2">
            <span>✨</span> ஸ்ரீ வைஷ்ணவ கேந்திரத்தின் பிரத்யேக வைதீக சேவைகள்:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm sm:text-base text-[#2D3748]">
            
            <div className="flex items-start gap-3 bg-[#FAF6EE] p-4 rounded-xl border border-[#F5EDDA] shadow-sm">
              <span className="text-[#CC6600] text-xl font-bold">✓</span>
              <div>
                <strong className="text-[#1A237E]">சாஸ்திர ரீதியான உறுதிப்பாடு:</strong>
                <p className="text-xs sm:text-sm text-[#4A5568] mt-1">
                  அனைத்து வைதீக கர்மாக்களும் சாஸ்திர ரீதியாகவும், ச்ரத்தையுடனும் அனுபவமிக்க வாத்யார்களால் நேர்த்தியாக செய்து கொடுக்கப்படும்.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-[#FAF6EE] p-4 rounded-xl border border-[#F5EDDA] shadow-sm">
              <span className="text-[#2D5A1E] text-xl font-bold">📍</span>
              <div>
                <strong className="text-[#1A237E]">இந்தியா முழுதும் சேவை:</strong>
                <p className="text-xs sm:text-sm text-[#4A5568] mt-1">
                  எந்த கர்மாவுக்கு வேண்டுமானாலும் வாத்யார், உப வாத்யார், ஜபம் செய்பவர்கள் - இந்தியா முழுதும் எங்கு வேண்டுமானாலும் நேரில் வந்து செய்து தருகிறோம்.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-[#FAF6EE] p-4 rounded-xl border border-[#F5EDDA] shadow-sm">
              <span className="text-[#4A148C] text-xl font-bold">📜</span>
              <div>
                <strong className="text-[#1A237E]">வேதம் &amp; ஸம்ப்ரதாய ஏற்பாடுகள்:</strong>
                <p className="text-xs sm:text-sm text-[#4A5568] mt-1">
                  யஜூர் வேதம், ஸாம வேதம் - வடகலை மற்றும் தென்கலை இரண்டு ஸம்ப்ரதாயங்களுக்கும் தனித்தனியாக வாத்யார்கள் ஏற்பாடு செய்யலாம்.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-[#FAF6EE] p-4 rounded-xl border border-[#F5EDDA] shadow-sm">
              <span className="text-[#C62828] text-xl font-bold">🏛️</span>
              <div>
                <strong className="text-[#1A237E]">கேந்திரத்தில் சுப வைபவங்கள் நடத்த வசதி:</strong>
                <p className="text-xs sm:text-sm text-[#4A5568] mt-1">
                  சுமார் 20 முதல் 25 பேருக்குள் பங்கேற்கக் கூடிய சுப வைபவங்களை ஸ்ரீ வைஷ்ணவ கேந்திரத்திற்கே வந்து அமோகமாக நடத்திக் கொள்ளலாம்.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-[#FAF6EE] p-4 rounded-xl border border-[#F5EDDA] shadow-sm md:col-span-2">
              <span className="text-[#E65100] text-xl font-bold">🍲</span>
              <div>
                <strong className="text-[#1A237E]">வருடாந்திர ச்ராத்தம் &amp; பரிசுத்தமான இடம்:</strong>
                <p className="text-xs sm:text-sm text-[#4A5568] mt-1">
                  வருடாந்திர ச்ராத்தம் முதலியவற்றுக்கும் வாத்யார், தளிகை, ஸ்வாமிகள் ஏற்பாடு செய்கிறோம். தவிர ச்ராத்தம் காண்ட்ராக்ட் முறையில் பண்ண ஸ்ரீ வைஷ்ணவ கேந்திரத்திலேயே தனியாக பரிசுத்தமான இடம் தனியாக உள்ளது.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-[#FDF8ED] p-5 rounded-xl border-2 border-[#CC6600] shadow-md md:col-span-2">
              <span className="text-[#CC6600] text-2xl font-bold">🌐</span>
              <div>
                <strong className="text-[#591717] text-base sm:text-lg">உள்நாடு &amp; வெளிநாட்டில் உள்ளவர்களுக்கு ஆன்லைன் சேவை (Online &amp; Video Call Services):</strong>
                <p className="text-xs sm:text-sm text-[#2D3748] mt-1 font-semibold leading-relaxed">
                  உள்ள நாடு மற்றும் வெளிநாட்டில் (NRI / Overseas) உள்ளவர்களுக்கும் இவை அனைத்து (23) கர்மாக்களும் ஆன்லைன் (Video Call) மூலமாகவும் சாஸ்திர முறைப்படி சிறப்பாக பண்ணிக்கொடுக்கப்படும்.
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* 23 Poorvam Karmas Grid */}
        <div className="mb-14">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#1A237E] inline-block border-b-4 border-[#CC6600] pb-2">
              பூர்வம்: சுப விசேஷங்கள் (23 வைதீக கர்மாக்கள் &amp; குறைந்த பக்ஷ ஸம்பாவனை)
            </h2>
            <p className="text-xs sm:text-sm text-[#4A5568] mt-2 font-medium">
              கீழ்க்கண்ட அனைத்து கர்மாக்களுக்கும் நமது ஸ்தாபனம் மூலம் சாஸ்திர ரீதியாக சிறந்த முறையில் சேவை வழங்கப்படுகிறது.
            </p>
            <div className="inline-block mt-3 bg-[#FAF6EE] border border-[#D4AF37] px-4 py-1.5 rounded-full text-xs font-bold text-[#591717] shadow-sm">
              🏷️ குறைந்த பக்ஷ ஸம்பாவனை விவரங்கள் கீழே ஒவ்வொரு கர்மாவிலும் குறிப்பிடப்பட்டுள்ளன.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {KARMA_LIST.filter(k => k.id !== 99).map((item) => (
              <div 
                key={item.id} 
                className="bg-[#FDF8ED] hover:bg-[#F5EDDA] transition duration-200 rounded-xl p-4 border border-[#D4AF37]/50 shadow-sm flex items-start gap-3 relative overflow-hidden"
              >
                <div className="w-9 h-9 rounded-full bg-[#1A237E] text-[#FAF6EE] font-bold text-sm flex items-center justify-center flex-shrink-0 shadow mt-0.5">
                  {item.id}
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-bold text-[#591717] text-sm sm:text-base truncate">
                    {item.ta}
                  </h3>
                  <p className="text-[11px] text-[#4A5568] truncate mb-2">
                    {item.en}
                  </p>
                  <div className="inline-flex items-center gap-1 bg-[#F5EDDA] border border-[#CC6600]/30 px-2.5 py-1 rounded-full text-xs font-semibold text-[#CC6600]">
                    <span>ஸம்பாவனை:</span>
                    <span className="font-bold text-[#1A237E]">{item.fee}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Booking & Inquiry Form Section */}
        <div className="bg-[#FDF8ED] rounded-3xl border-2 border-[#D4AF37] shadow-2xl overflow-hidden max-w-4xl mx-auto">
          
          <div className="bg-[#1A237E] text-[#FAF6EE] p-6 sm:p-8 text-center border-b-4 border-[#D4AF37]">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#FDF8ED] mb-2">
              📝 வைதீக கர்மா முன்பதிவு / தகவல் படிவம்
            </h2>
            <p className="text-xs sm:text-sm text-[#F5EDDA]">
              தங்கள் தேவை பற்றிய விபரங்களை பூர்த்தி செய்யவும். உடனடியாக தொடர்புகொண்டு உறுதி செய்யப்படும்.
            </p>
          </div>

          <div className="p-6 sm:p-10">

            {submitSuccess && (
              <div className="bg-[#2D5A1E]/10 border-2 border-[#2D5A1E] text-[#1B5E20] p-6 rounded-2xl mb-8 text-center">
                <div className="text-4xl mb-2">✅</div>
                <h3 className="text-xl font-bold mb-2">தங்கள் தகவல் வெற்றிகரமாக அனுப்பப்பட்டது!</h3>
                <p className="text-sm text-[#4A5568]">
                  ஸ்ரீ.உப.வே. ஸ்ரீநிவாசாசாரியார் ஸ்வாமிகள் தங்களிடம் விரைவில் தொடர்புகொள்வார். அவசரத் தேவைக்கு வாட்ஸ்அப்பில் தொடர்பு கொள்ளவும்.
                </p>
                <button
                  type="button"
                  onClick={() => setSubmitSuccess(false)}
                  className="mt-4 px-6 py-2 bg-[#2D5A1E] text-[#FAF6EE] text-sm font-bold rounded-lg hover:bg-[#1B5E20] transition"
                >
                  மற்றொரு கர்மா முன்பதிவு செய்ய
                </button>
              </div>
            )}

            {errorMessage && (
              <div className="bg-[#C62828]/10 border-2 border-[#C62828] text-[#C62828] p-4 rounded-xl mb-6 text-sm font-semibold">
                ⚠️ {errorMessage}
              </div>
            )}

            <form onSubmit={handleSubmitServer} className="space-y-6">

              {/* Name & Phone */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-xs font-bold text-[#1A237E] uppercase tracking-wider mb-2">
                    1. பெயர் (Name) <span className="text-[#C62828]">*</span>
                  </label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="உங்கள் பெயர்"
                    className="w-full px-4 py-3 border border-[#D4AF37]/60 rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#1A237E] focus:border-transparent text-sm font-medium shadow-inner"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-xs font-bold text-[#1A237E] uppercase tracking-wider mb-2">
                    2. தொடர்பு / WhatsApp எண் <span className="text-[#C62828]">*</span>
                  </label>
                  <input
                    id="phone"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="எ.கா: 9840012345"
                    className="w-full px-4 py-3 border border-[#D4AF37]/60 rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#1A237E] focus:border-transparent text-sm font-medium shadow-inner"
                    required
                  />
                  <span className="text-[11px] text-[#718096] mt-1 block">
                    (சரிபார்க்க வாட்ஸ்அப் எண் அவசியம்)
                  </span>
                </div>
              </div>

              {/* Karma Detail Dropdown & Veda Sampradaya */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="karmaDetail" className="block text-xs font-bold text-[#1A237E] uppercase tracking-wider mb-2">
                    3. கர்மா விபரம் (Karma Detail) <span className="text-[#C62828]">*</span>
                  </label>
                  <select
                    id="karmaDetail"
                    name="karmaDetail"
                    value={formData.karmaDetail}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-[#D4AF37]/60 rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#1A237E] focus:border-transparent text-sm font-medium shadow-sm"
                  >
                    {KARMA_LIST.map((k) => (
                      <option key={k.id} value={k.ta}>
                        {k.id !== 99 ? `${k.id}. ${k.ta} (ஸம்பாவனை: ${k.fee})` : k.ta}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="vedaSampradaya" className="block text-xs font-bold text-[#1A237E] uppercase tracking-wider mb-2">
                    வேதம் &amp; ஸம்ப்ரதாயம் விருப்பம்
                  </label>
                  <select
                    id="vedaSampradaya"
                    name="vedaSampradaya"
                    value={formData.vedaSampradaya}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-[#D4AF37]/60 rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#1A237E] focus:border-transparent text-sm font-medium shadow-sm"
                  >
                    <option value="யஜூர் வேதம் - வடகலை">யஜூர் வேதம் - வடகலை</option>
                    <option value="யஜூர் வேதம் - தென்கலை">யஜூர் வேதம் - தென்கலை</option>
                    <option value="ஸாம வேதம் - வடகலை">ஸாம வேதம் - வடகலை</option>
                    <option value="ஸாம வேதம் - தென்கலை">ஸாம வேதம் - தென்கலை</option>
                    <option value="ருக் வேதம்">ருக் வேதம்</option>
                    <option value="மற்றவை / பொதுவானது">மற்றவை / பொதுவானது</option>
                  </select>
                </div>
              </div>

              {/* Other Karma Input field if selected */}
              {formData.karmaDetail === 'மற்றவை (Other Vaidhika Karma...)' && (
                <div>
                  <label htmlFor="otherKarma" className="block text-xs font-bold text-[#591717] uppercase tracking-wider mb-2">
                    கர்மா பெயர் உள்ளிடவும் (Specify Karma Name)
                  </label>
                  <input
                    id="otherKarma"
                    type="text"
                    name="otherKarma"
                    value={formData.otherKarma}
                    onChange={handleInputChange}
                    placeholder="எ.கா: ஆயுஷ்ய ஹோமம் / சஷ்டியப்தபூர்த்தி..."
                    className="w-full px-4 py-3 border border-[#CC6600] rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#CC6600] text-sm font-medium shadow-inner"
                  />
                </div>
              )}

              {/* Karma Date & Karma Place */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="karmaDate" className="block text-xs font-bold text-[#1A237E] uppercase tracking-wider mb-2">
                    4. கர்மா உத்தேசித்துள்ள தேதி (Karma Date)
                  </label>
                  <input
                    id="karmaDate"
                    type="date"
                    name="karmaDate"
                    value={formData.karmaDate}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-[#D4AF37]/60 rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#1A237E] text-sm font-medium shadow-sm"
                  />
                </div>

                <div>
                  <label htmlFor="karmaPlace" className="block text-xs font-bold text-[#1A237E] uppercase tracking-wider mb-2">
                    5. கர்மா நடைபெறும் இடம் / ஊர் (Karma Place)
                  </label>
                  <input
                    id="karmaPlace"
                    type="text"
                    name="karmaPlace"
                    value={formData.karmaPlace}
                    onChange={handleInputChange}
                    placeholder="எ.கா: சென்னை / ஸ்ரீ வைஷ்ணவ கேந்திரம் / உங்கள் ஊர்"
                    className="w-full px-4 py-3 border border-[#D4AF37]/60 rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#1A237E] text-sm font-medium shadow-sm"
                  />
                </div>
              </div>

              {/* Address (Optional) */}
              <div>
                <label htmlFor="address" className="block text-xs font-bold text-[#1A237E] uppercase tracking-wider mb-2">
                  6. தொடர்பு முகவரி (Party Address) <span className="text-[#718096] text-[11px] font-normal">(விருப்பப்பட்டால்)</span>
                </label>
                <textarea
                  id="address"
                  name="address"
                  rows="3"
                  value={formData.address}
                  onChange={handleInputChange}
                  placeholder="வீட்டு கதவு எண், தெரு, நகர், அஞ்சல் குறியீட்டு எண்..."
                  className="w-full px-4 py-3 border border-[#D4AF37]/60 rounded-xl bg-[#FAF6EE] text-[#2D3748] focus:ring-2 focus:ring-[#1A237E] text-sm font-medium shadow-inner"
                ></textarea>
              </div>

              {/* reCAPTCHA Widget */}
              <div className="bg-[#FAF6EE] p-4 rounded-xl border border-[#D4AF37]/40 flex justify-center">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LcHtHctAAAAAEBv7fRnOnUWot2HppbIt6-K6UE4'}
                  onChange={(token) => setRecaptchaToken(token)}
                  onExpired={() => setRecaptchaToken(null)}
                />
              </div>

              {/* Action Buttons */}
              <div className="pt-2 flex flex-col sm:flex-row gap-4">
                
                <button
                  type="button"
                  onClick={handleWhatsAppClick}
                  className="flex-1 bg-[#2D5A1E] hover:bg-[#1B5E20] text-[#FAF6EE] py-4 px-6 rounded-xl font-bold text-base shadow-lg transition duration-200 flex items-center justify-center gap-2 border border-[#D4AF37]"
                >
                  <span>💬 வாட்ஸ்அப் மூலம் உடனடியாக அனுப்ப</span>
                </button>

                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 bg-gradient-to-r from-[#591717] to-[#1A237E] hover:from-[#7B1E1E] hover:to-[#0D47A1] text-[#FAF6EE] py-4 px-6 rounded-xl font-bold text-base shadow-lg transition duration-200 disabled:opacity-50 flex items-center justify-center gap-2 border border-[#D4AF37]"
                >
                  <span>{loading ? '⏳ அனுப்பப்படுகிறது...' : '✉️ இணையம் வழியே சமர்ப்பிக்க'}</span>
                </button>

              </div>

            </form>
          </div>
        </div>

        {/* Direct Contact Footer Info */}
        <div className="mt-12 text-center bg-[#FDF8ED] p-8 rounded-2xl border border-[#D4AF37]/60 shadow-md">
          <h3 className="text-xl font-bold text-[#591717] mb-2">
            நேரடி தொடர்புக்கு (Direct Contact)
          </h3>
          <p className="text-base text-[#1A237E] font-semibold">
            ஸ்ரீ.உப.வே. ஸ்ரீநிவாசாசாரியார் ஸ்வாமின் <span className="text-xs text-[#591717]">(MA, M.Phil, PhD)</span>
          </p>
          <p className="text-sm text-[#4A5568] mt-1">
            ஸ்ரீ வைஷ்ணவ கேந்திரம் (நிறுவப்பட்ட நாள்: 19-ஆகஸ்ட்-1989)
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-6 text-sm font-bold text-[#CC6600]">
            <a href="tel:+918610736302" className="hover:underline">📞 8610736302</a>
            <a href="mailto:svknvs@gmail.com" className="hover:underline">✉️ svknvs@gmail.com</a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default VaidhikaServicesPage;
